import React, { useState, useMemo } from 'react';

import 'components/UploadAssetLibrary/UploadAssetLibrary.scss';

import Modal from 'components/Common/Modal/Modal';
import Search from 'components/Common/Search/Search';
import Breadcrumbs, { IPages } from 'components/Common/Breadcrumbs/Breadcrumbs';
import FolderIcon from 'assets/icons/Icon-folder.svg';
import ArrowIcon from 'assets/icons/angle-right-gray.svg';

export interface IOptions {
  label: string;
}

export interface IFilterDropdowns {
  label: string;
  options: IOptions[];
}

export interface IStyleSampleMoveToModal {
  headingText: string;
  folders: any;
  options?: IOptions[];
  filterDropdowns?: IFilterDropdowns[];
  open: boolean;
  setOpen?: (open: boolean) => void;
  onSelect?: (key?: number) => void;
}

const StyleSampleMoveToModal: React.FC<IStyleSampleMoveToModal> = props => {
  const { headingText, folders, open, setOpen, onSelect } = props;

  const [search, setSearch] = useState('');

  const [folderKeyPath, setFolderKeyPath] = useState([]);
  const folderPath = useMemo(
    () => folderKeyPath.map(key => folders.find(folder => folder.key === key).name),
    [folderKeyPath, folders]
  );
  const activeFolders = useMemo(
    () =>
      folders.filter(folder => {
        if (folder.path.length != folderKeyPath.length) {
          return false;
        }
        for (let i = 0; i < folderKeyPath.length; i++) {
          if (folder.path[i] != folderKeyPath[i]) {
            return false;
          }
        }
        return true;
      }),
    [folders, folderKeyPath]
  );

  const onSubmit = e => {
    e.preventDefault();
    onSelect?.(
      folderPath.length > 0 ? folderKeyPath[folderKeyPath.length - 1] : undefined
    );
    setOpen(false);
  };

  const pages = useMemo(() => {
    const pagesArray = [];
    let link = '/';
    for (let i = 0; i < folderKeyPath.length; i += 1) {
      const key = folderKeyPath[i];
      const p = folderPath[i];
      link += `/${p}`;
      const page: IPages = {
        title: p,
      };
      if (i < folderKeyPath.length - 1) {
        page.link = link;
        page.onClick = () => setFolderKeyPath(folderKeyPath.slice(0, i + 1));
      }
      pagesArray.push(page);
    }
    if (folderKeyPath.length > 0) {
      pagesArray.push({
        title: '<',
        link: '/',
        onClick: () => setFolderKeyPath(folderKeyPath.slice(0, folderKeyPath.length - 1)),
      });
    }
    return pagesArray;
  }, [folderKeyPath]);

  const filteredFolders = activeFolders?.filter(f =>
    f.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className='upload-asset-library'>
      <Modal
        modalHeading={headingText}
        modalBtnClose='Cancel'
        modalBtnActionLabel='Move'
        modalBtnActionHandler={onSubmit}
        backgroundColor='#fff'
        modalOpen={open}
        setModalOpen={setOpen}
      >
        <div className='upload-asset-library__body'>
          <div className='upload-asset-library__search'>
            <Search changeHandler={setSearch} />
          </div>
          <Breadcrumbs pages={pages} />
          <div className='upload-asset-library__folders'>
            {filteredFolders &&
              filteredFolders.map(({ key, name }, idx) => (
                <div key={name} className='upload-asset-library__folder'>
                  <span
                    className='upload-asset-library__folder__heading-flex'
                    onClick={() => setFolderKeyPath([...folderKeyPath, key])}
                  >
                    <img
                      src={FolderIcon}
                      className='upload-asset-library__folder__folder-icon'
                      alt={name}
                    />
                    {name}
                  </span>
                  <div className='upload-asset-library__folder__arrow-icon'>
                    <img src={ArrowIcon} alt='Open' />
                  </div>
                </div>
              ))}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default StyleSampleMoveToModal;
